import { useAuth } from '@/hooks/useAuth';
import { AppLayout } from './AppLayout';
import { PublicLayout } from './PublicLayout';

/**
 * Chrome for a route that one URL serves to BOTH audiences: the member nav when
 * there is a session, the marketing header when there is not.
 *
 * Only for genuinely dual-audience pages - today the event detail page, which is
 * shared and deep-linked from the public Home events section yet also opened by
 * members from their dashboard. It is not a way to make an authenticated page
 * public: the page itself still decides what a logged-out viewer may see and do.
 *
 * A single path can only be mounted once, so the alternative was either leaving
 * the route behind `ProtectedRoute` (anonymous visitors bounce to login, the bug)
 * or moving it under `PublicLayout` outright (members lose their nav and get
 * "Sign In / Get Started" on a page they reached from inside the app).
 *
 * Renders nothing while the session hydrates, so a member never sees the public
 * header flash before their own nav resolves - the same reason `ProtectedRoute`
 * waits on `isLoading` rather than treating "not yet known" as "logged out".
 */
export function ViewerAdaptiveLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return null;
  return isAuthenticated ? <AppLayout /> : <PublicLayout />;
}
